export const IMAGE_API_URL = document.getElementById('image-api-url').getAttribute('content')
